import React, {FunctionComponent} from 'react';
import cx from 'classnames';

import styles from './icon-button.module.css';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant: 'primary' | 'secondary';
}

const IconButton: FunctionComponent<Props> = props => {
  const {children, className, variant, ...rest} = props;

  return (
    <button
      className={cx(className, styles.iconButton, styles[variant])}
      {...rest}>
      {children}
    </button>
  );
};

export default IconButton;
